import { HelpOutline } from "@mui/icons-material"
import { Tooltip, Typography, Box } from "@mui/material"

export const ModuleFeeTooltip = () => {
    return (
        <Tooltip 
            title={
                <Box sx={{ p: 0.5 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                        Module Fee
                    </Typography>
                    <Typography variant="body2">
                        A per-user monthly charge that provides access to specific modules within the Extraordinary platform.
                    </Typography>
                </Box>
            } 
            sx={{ marginRight: "auto", marginLeft: "4px" }}
        >
            <HelpOutline />
        </Tooltip>
    )
}